// relative path to file: lib/gtag.js

export const event = ({ clientWindow, action, category, label, value }) => {
    clientWindow.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
    });
};